import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck, Users } from "lucide-react";
import { RelayMark, BrandLockup } from "@/components/brand";
import { Panel } from "@/components/kit";

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-5 py-10 md:py-16 vda-rise">
        <p className="vda-tick text-[hsl(var(--vda-clay))] mb-4">Fleet driver assistance</p>
        <BrandLockup />
        <p className="mt-6 max-w-xl text-base text-foreground/80">
          Submit MOT, service, repair and assistance requests for your allocated vehicle,
          then track every booking through to collection. One dependable service layer for
          drivers, account teams and fleet managers.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <Panel className="p-6 flex flex-col">
            <ShieldCheck className="h-5 w-5 text-[hsl(var(--vda-clay))]" />
            <h2 className="mt-4 text-lg font-semibold">I'm a driver</h2>
            <p className="mt-1 text-sm text-muted-foreground flex-1">
              Verify with your vehicle registration and mobile number.
            </p>
            <button data-testid="enter-driver"
              onClick={() => nav("/verify")}
              className="mt-6 inline-flex items-center justify-between gap-2 bg-primary text-primary-foreground h-11 px-4 text-sm font-medium rounded-[3px] hover:bg-primary/90">
              Verify my details <ArrowRight className="h-4 w-4" />
            </button>
          </Panel>

          <Panel className="p-6 flex flex-col">
            <Users className="h-5 w-5 text-[hsl(var(--vda-clay))]" />
            <h2 className="mt-4 text-lg font-semibold">Staff &amp; fleet managers</h2>
            <p className="mt-1 text-sm text-muted-foreground flex-1">
              Account teams and external fleet managers sign in with email.
            </p>
            <button data-testid="enter-staff"
              onClick={() => nav("/login")}
              className="mt-6 inline-flex items-center justify-between gap-2 border border-[hsl(var(--input))] h-11 px-4 text-sm font-medium rounded-[3px] hover:bg-secondary">
              Sign in <ArrowRight className="h-4 w-4" />
            </button>
          </Panel>
        </div>

        <p className="mt-12 text-xs text-muted-foreground">
          Development build. Verification uses a clearly labelled test code — no live SMS or email is sent.
        </p>
      </div>
    </div>
  );
}
